import {RootState} from "./rootState";
import {combineReducers, ReducersMapObject} from "redux";
import authReducer from "./../auth/authReducer"
import settingsReducer from "./../settings/settingsReducer"

export const rootReducer = combineReducers<RootState>(
    {
        auth: authReducer,
        settings: settingsReducer
    } as ReducersMapObject<RootState>);